import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { InlineInfoBoxProps as Props } from './types';

export const InlineInfoBox = memo(({ className, type, item }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('InlineInfoBox', className)}
      sx={SX.root(type)}
    >
      <Icon size={18} name="info-circle-outline" sxx={SX.icon(type)} />
      <Typography variant="body4" fontWeight={400} sx={SX.text}>
        {type === 'pending-invite' && `Pending Email Confirmation`}

        {type === 'pending-transfer-ownership' &&
          `Please check your inbox at to complete the transfer.`}
      </Typography>
    </Styled.Wrapper>
  );
});

InlineInfoBox.displayName = 'InlineInfoBox';
